/**
 * Verifica la compatibilità del browser con l'applicazione.
 *
 * Minimi supportati:
 * - Edge: 121+
 * - Chrome: 109+
 * - Firefox: 115+
 * - Safari (iOS/iPadOS/macOS WebKit): 15.4+
 *
 * @returns {boolean} True se compatibile, false altrimenti
 */
function isBrowserCompatible(): boolean {
  try {
    if (!navigator || typeof navigator.userAgent !== 'string') {
      console.warn('Navigator o userAgent non disponibili; consento accesso.');
      return true; // come nel tuo codice originale
    }

    const ua = navigator.userAgent;

    // iOS/iPadOS detection (iPad con “sito desktop” si presenta come Macintosh + touch)
    const isIOSLike =
      /\b(iPad|iPhone|iPod)\b/i.test(ua) ||
      (/\bMacintosh\b/.test(ua) && (navigator as any).maxTouchPoints > 1);

    if (isIOSLike) {
      // Trattiamo tutti i browser iOS come Safari/WebKit e verifichiamo la versione
      // 1) Prova con "Version/x.y"
      const versionMatch = ua.match(/Version\/(\d+(?:\.\d+)?)/);
      if (versionMatch) {
        return parseFloat(versionMatch[1]) >= 15.4;
      }
      // 2) Altrimenti prova a leggere la versione di iOS: "OS 15_4"
      const osMatch = ua.match(/OS (\d+)_(\d+)/i);
      if (osMatch) {
        const major = parseInt(osMatch[1], 10);
        const minor = parseInt(osMatch[2], 10);
        return major > 15 || (major === 15 && minor >= 4);
      }
      // 3) Se non riusciamo a determinare la versione con certezza → NON compatibile
      console.warn(
        'iOS/iPadOS rilevato ma versione non determinabile → non supportato.',
      );
      return false;
    }

    // Edge (Chromium) 121+
    const edgeMatch = ua.match(/Edg\/(\d+)/);
    if (edgeMatch) return parseInt(edgeMatch[1], 10) >= 121;

    // Chrome 109+ (esclude Edge e Opera)
    const chromeMatch = ua.match(/Chrome\/(\d+)/);
    if (chromeMatch && !ua.includes('Edg/') && !/\bOPR\/\d+/.test(ua)) {
      return parseInt(chromeMatch[1], 10) >= 109;
    }

    // Firefox 115+
    const firefoxMatch = ua.match(/Firefox\/(\d+)/);
    if (firefoxMatch) return parseInt(firefoxMatch[1], 10) >= 115;

    // Safari 15.4+ (macOS)
    const isSafariDesktop =
      ua.includes('Safari') &&
      !ua.includes('Chrome') &&
      !ua.includes('Edg/') &&
      !/\bOPR\/\d+/.test(ua);
    if (isSafariDesktop) {
      const safariVersionMatch = ua.match(/Version\/(\d+(?:\.\d+)?)/);
      if (safariVersionMatch) {
        return parseFloat(safariVersionMatch[1]) >= 15.4;
      }
      // Se Safari senza "Version/": non determinabile → non supportato
      return false;
    }

    // Tutto il resto → non supportato (coerente con la riga "Altri")
    console.warn('Browser non riconosciuto → non supportato.');
    return false;
  } catch (err) {
    console.error('Errore durante il controllo della compatibilità:', err);
    return true; // coerenza con tua scelta: non bloccare in caso di errore inatteso
  }
}

export default isBrowserCompatible;
